module.exports = __webpack_public_path__ + "static/media/SD.f32edcde.png";